/* eslint-disable @typescript-eslint/no-empty-function */
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { USER_ACCOUNT_TYPE } from '~core/models/auth.models';
import { AdminCreationFormComponent } from '../../modals/admin-creation-form/admin-creation-form.component';
import { SettingsModule } from '../../settings.module';

@Component({
  selector: 'administrators',
  standalone: true,
  imports: [SettingsModule],
  templateUrl: './administrators.component.html',
  styleUrls: ['./administrators.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministratorsComponent
  implements OnInit, AfterContentInit, OnDestroy
{
  paginationData$ = this.resourceFacade.paginationData$;
  private _destroy$ = new Subject<void>();
  accountType = USER_ACCOUNT_TYPE;

  constructor(
    private dialogService: DialogService,
    private resourceFacade: ResourceFacade
  ) {}

  ngOnInit(): void {
    this.resourceFacade.resetState({ disposition: 'list' });
  }

  ngAfterContentInit(): void {
    this.resourceFacade.applyFilters({
      accountType: `neq(${this.accountType.CUSTOMER})`
    });
    this.resourceFacade.getData();
  }

  ngOnDestroy(): void {
    this.resourceFacade.resetState();
    this._destroy$.next();
    this._destroy$.unsubscribe();
  }

  searchByName(value: string | null): void {
    this.resourceFacade.applyFilters({
      name: value ? `like(%${value}%)` : null
    });
  }

  searchByFilters(filters: Record<string, unknown>): void {
    this.resourceFacade.applyFilters(filters);
  }

  openModal(): void {
    const dialogRef = this.dialogService.open({
      component: AdminCreationFormComponent,
      config: {
        panelClass: ['mat-dialog-custom-full-screen'],
        disableClose: true,
        height: '100vh',
        width: '100vw',
        maxWidth: '100vw'
      }
    });

    dialogRef
      .afterClosed()
      .pipe(
        takeUntil(this._destroy$),
        filter(Boolean),
        tap({
          next: () => {
            this.resourceFacade.getData({ refresh: true });
          }
        })
      )
      .subscribe();
  }
}
